import React, { useEffect, useContext, useState, useMemo } from "react";
import { TokenVerificationLoggedin, ScreenView } from "../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import { Table, Select, Col, Row, Pagination, Input } from 'antd';
import mediaKitIcon from '../assets/images/icons/download.svg';
import { Link } from 'react-router-dom'
import FullLoader from "../assets/images/full-page-loader.gif"
import prevIcon from '../assets/images/icons/chevron-left.svg';
import nextIcon from '../assets/images/icons/chevron-right.svg';
import { jwtDecode } from "jwt-decode";
import noData from '../assets/images/data-graph/no-data.svg';
import TableLoader from "./TableLoader";
import errorData from '../assets/images/data-graph/error-data.svg';
import uploadIcon from '../assets/images/icons/upload-cloud.svg';
import loaderIcon from '../assets/images/icons/loader.gif';
import { saveAs } from "file-saver";

const AdTxtUpload = () => {
    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    const [checkRole, setCheckRole] = useState("admin")

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)
    const [uploadLoader, setUploadLoader] = useState(false)
    const [downloadLoader, setDownloadLoader] = useState(false)
    const [pageLoad, setPageLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });

    const [search, setSearch] = useState("")

    // const [sort, setSort] = useState({
    //     name: "",
    //     type: ""
    // });


    const columnsAll = [
        {
            title: 'File Name',
            dataIndex: 'File Name',
            key: "File Name",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            width: 100,
            sorter: (a, b) => a['File Name'].localeCompare(b['File Name']),
            render: (text, record) => <div className='d-flex'>
                {text}
                {record.live &&
                    <div className='badge_content--approved live_badge'><span className='badge_inner_text'>Live</span></div>
                }
            </div>,
        },
        {
            title: 'Uploaded By',
            dataIndex: 'Uploaded by',
            key: "Uploaded by",
            width: 200,
            sortDirections: ['ascend', 'descend', 'ascend'],
            // sorter: true,
            render: (text) => <div className='d-flex'>
                {text}
            </div>,

        },
        {
            title: 'Date Added',
            dataIndex: 'Date added',
            key: "Date added",
            width: 200,
            sortDirections: ['ascend', 'descend', 'ascend'],
            // sorter: true,
            render: (text) => <div className='d-flex'>

                {text}
            </div>,

        },
        {
            title: 'File',
            dataIndex: 'File',
            key: "File",
            render: () => <button className='btn_icon btn'><img src={mediaKitIcon} alt='USP' /></button>,
            width: 100,
            sortDirections: ['ascend', 'descend', 'ascend'],
            // sorter: true,
            render: (_, record) => {
                return (
                    <div className='d-flex'>

                        <button className='download_icon download_icon_d2'
                            onClick={() => {
                                handleDownload(record._id)

                            }}
                        ><img src={mediaKitIcon} alt='USP' /></button>
                    </div>
                )
            }

        },

    ];


    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                // .get(configData.SERVER_URL + `zone/fileList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
                .get(configData.SERVER_URL + `zone/fileList`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data)
                    if (response.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.length

                        setPage(tempPage)
                    }


                    setLoading(false)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView()
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole)
            if (checkRole !== "admin") {
                getData()
            }

        }


        setTimeout(() => {
            setPageLoad(false)
        }, 500)


        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad && checkRole !== "admin") {
            getData()
        }
    }, [apiCall])

    // useEffect(() => {
    //     if (!initialLoad) {
    //         const delayDebounceFn = setTimeout(() => {
    //             setApicall(!apiCall)
    //         }, 400); // 500ms delay
    //         // Cleanup function to clear the timeout if query changes
    //         return () => clearTimeout(delayDebounceFn);
    //     }
    // }, [search]);



    // const handleTableChange = (pagination, filters, sorter) => {
    //     setSort({ name: sorter.field, type: sorter.order });
    //     setApicall(!apiCall)
    // };

    // const handlePageChange = (data) => {

    //     let tempPage = page
    //     tempPage.current = data
    //     setPage(tempPage);
    //     setApicall(!apiCall)
    // };

    // const handlePageSizeChange = (e) => {
    //     let tempPage = page
    //     tempPage.pageSize = e

    //     if (tempPage.current > 1) {
    //         if (e * tempPage.current > tempPage.total) {
    //             tempPage.current = tempPage.current - 1
    //         }
    //     }
    //     setPage(tempPage);
    //     setApicall(!apiCall)
    // };

    // const itemRender = (current, type, originalElement) => {
    //     if (type === 'prev') {
    //         return <Link><img src={prevIcon} alt='USP' /></Link>;
    //     }
    //     if (type === 'next') {
    //         return <Link><img src={nextIcon} alt='USP' /></Link>;
    //     }
    //     return originalElement;
    // };


    const locale = {
        emptyText:
            <>{search.trim().length > 0 ?
                <div className='no_data_screen'>
                    <div className='text-center'>
                        <img src={errorData} className='' alt="" />
                        {/* <div className='float_text_div'>
                            <h1 className='no_data_heading'>Whoops! Looks like there’s no data.</h1>
                            <p className='no_data_para'>The resource you are looking for is not <br /> available</p>
                        </div> */}
                    </div>
                </div>
                :
                <div className='no_data_screen' >
                    <div className='text-center'>
                        <img src={noData} className='' alt="" />
                        {/* <div className='float_text_div'>
                            <h1 className='no_data_heading'>Whoops! Looks like there’s no data.</h1>
                            <p className='no_data_para'>There are no records to show you right <br /> now.</p>
                        </div> */}
                    </div>
                </div>
            }
            </>

    };

    const components = {
        header: {
            wrapper: (props) => (
                <thead {...props}>
                    {props.children}
                </thead>
            ),
        },

        body: {
            wrapper: (props) => (
                <tbody {...props}>
                    {loading ? (
                        <>
                            <div className='loader_top_space'>
                                <div className="inside_table_two_loader">
                                    <img src={FullLoader} className="" alt="" />
                                </div>
                            </div>


                        </>
                    ) : (
                        props.children
                    )}
                </tbody>
            ),
        },
    };


    const filterData = useMemo(() => {
        if (search === "") {
            return data
        }
        else {
            return data.filter(item => (item['File Name']?.toLowerCase().includes(search.toLowerCase()) ||
                item['Uploaded by']?.toLowerCase().includes(search.toLowerCase()))
            );
        }
    }, [data, search]);


    const handleDownload = async (id) => {
        let token = Cookies.get("token_xapads_ssp");
        setDownloadLoader(true)

        axios
            .get(
                configData.SERVER_URL +
                `zone/downloadAdstxt?_id=` +
                id,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                }
            )
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: "text/plain;charset=utf-8",
                });
                saveAs(blob, "Ads.txt");

                notifysuccess("File downloaded successfully.")
                setDownloadLoader(false)
            })
            .catch((error) => {
                if (error?.response) {
                    if (error?.response?.data?.message?.length !== 0) {
                        notifyfailure("Unable to download the file.");
                    }
                } else {
                    notifycatch();
                }

                setDownloadLoader(false)

            });
    };


    function onChangeMediakit(e) {
        if (e.target.files[0] !== undefined) {

            let formData = new FormData();
            formData.append('adsTxt', e.target.files[0]);

            // e.target.files[0].type === "text/csv"

            if (e.target.files[0].size / (1024 * 1024) < 100 && (e.target.files[0].type === "text/plain")) {


                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setUploadLoader(true);
                    let token = Cookies.get("token_xapads_ssp");
                    //   let id = jwtDecode(token)._id;

                    axios
                        .post(configData.SERVER_URL + `zone/uploadAdsTxt`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {
                            notifysuccess(response.data.message);
                            setUploadLoader(false);
                            setApicall(!apiCall)


                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setUploadLoader(false);
                        });




                }
            }
            else {
                notifyfailure("File should be in .txt format and less than 100 mb")
            }



        }
    }


    return (
        <>


            <div className="container_box--wrapper pt_header"
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Ads.txt
                    </h1>

                </div>
                {!pageLoad ?
                    <>
                        {checkRole === "admin" ?


                            <div className="d_flex pt_20">
                                <div className="content_box--card">
                                    <div className="content_box--card-header">
                                        <h4 className='heading'>Download Ads.txt</h4>
                                    </div>
                                    <div className="content_box--card-body">
                                        <p className="text">
                                            Please upload our lines in your ads.txt. If you have already updated your ads.txt remember that our systems scan the ads.txt every 30 minutes.
                                        </p>
                                        {!downloadLoader ?
                                            <button className='btn btn_primary w_fit_content mx_width'
                                                onClick={() => { handleDownload("") }}
                                            >
                                                <span>Download</span>
                                                <img src={loaderIcon} alt='USP' className='loader_icon' />
                                            </button>
                                            :
                                            <button
                                                className="btn btn_primary w_fit_content mx_width loader"

                                            >
                                                <span>Create Zone</span>

                                                <img
                                                    src={loaderIcon}
                                                    alt="USP"
                                                    className="loader_icon"
                                                />
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>

                            :

                            <Row gutter={16} className='mb-5 ads_uploader'>
                                <Col span={15}>
                                    {uploadLoader ?

                                        <div className="form_content_block--group">
                                            <label for='test' className='ant_upload_drag'>

                                                <div
                                                    className="d-flex justify-content-center align-items-center"
                                                >
                                                    <img
                                                        src={FullLoader}
                                                        width={50}
                                                        height={50}
                                                        alt="" />
                                                </div>
                                            </label>
                                            <input className='form_upload d-none' type="file"
                                                name="file004"
                                                id="file004"
                                                accept=".txt, .csv"
                                                onChange={onChangeMediakit}
                                            />
                                        </div>
                                        :
                                        <div className="form_content_block--group">
                                            <label for='file004' className='ant_upload_drag'>
                                                <p className="upload_drag_icon">
                                                    <img src={uploadIcon} alt='USP' />
                                                </p>
                                                <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                                <p className="ant_upload_hint">
                                                    .txt (max. 100 MB)
                                                </p>
                                            </label>
                                            <input className='form_upload d-none' type="file"
                                                name="file004"
                                                id="file004"
                                                accept=".txt"
                                                onChange={onChangeMediakit}
                                            />
                                        </div>
                                    }


                                </Col>

                                <Col span={15}>
                                    <div className="d_flex justify_content_between  mb_10 between_space_gap">
                                        <div className="form_content_block--group">
                                            {!initialLoad &&
                                                <Input
                                                    type='text'
                                                    className='form_control basic md search_input w_table_search'
                                                    placeholder="Search"
                                                    value={search}
                                                    onChange={(e) => {

                                                        // if (e.target.value.trim().length === 0) {
                                                        //     setLoading(true)
                                                        // }

                                                        setSearch(e.target.value)
                                                    }}
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className="table_content--box addtxt_table_d2 table_empty_screen_d2">
                                        {initialLoad ?
                                            <TableLoader />

                                            :
                                            <Table
                                                columns={columnsAll}
                                                pageSize={100}
                                                dataSource={filterData}
                                                // onChange={handleTableChange}
                                                pagination={false}
                                                rowKey={(record) => record.id}
                                                locale={locale}
                                                components={components}
                                                scroll={{ x: 'max-Content', y: 'calc(100vh - 42rem' }} />


                                        }

                                        {/* {data.length > 0 &&
                                    <Row className="custom_pagination--container">
                                        <Col span={6}>
                                            <div className="form_content_block--group mb_0">
                                                <Select
                                                    className='form_select basic sm no_search'
                                                    value={page.pageSize}
                                                    onChange={handlePageSizeChange}
                                                    style={{ width: 80 }}
                                                    showSearch={false}
                                                    options={[
                                                        { value: 10, label: 10 },
                                                        { value: 20, label: 20 },
                                                        { value: 50, label: 50 },
                                                        { value: 100, label: 100 },
                                                    ]} />
                                                <label className='custom_pagination--label'>
                                                    items per page
                                                </label>
                                            </div>
                                        </Col>
                                        <Col span={6}>
                                            <span className="custom_pagination--total-text">
                                                {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                            </span>
                                        </Col>
                                        <Col span={6}>
                                            <Pagination
                                                current={page.current}  // Pass individual props instead of spreading them
                                                pageSize={page.pageSize}
                                                total={page.total}
                                                onChange={handlePageChange}
                                                showSizeChanger={false}
                                                itemRender={itemRender}
                                                className="custom_pagination" />
                                        </Col>
                                    </Row>
                                } */}

                                    </div>
                                </Col>
                            </Row>
                        }
                    </>
                    :
                    <div
                        style={{ width: "100%", height: "60vh" }}
                        className="d-flex justify-content-center align-items-center"

                    >
                        <img
                            src={FullLoader}
                            width={50}
                            height={50}
                            alt="" />
                    </div>
                }

            </div >



        </>
    );
};

export default AdTxtUpload;
